const routes = [
    {
        path: "",
        redirect: "/home"
    },

    {
        name: "home",
        path: "/home",
        component: () => import("@/view/home"),
        meta: {
            title: "首页",//天安金交中心
            auth: false
        }
    },
    {
        name: 'ruledetail',
        path: "/home/ruledetail",
        component: () => import("@/view/home/ruledetail"),
        meta: {
            title: "活动规则说明",
        }
    },

    {
        name: "login",
        path: "/login",
        component: () => import("@/view/login"),
        meta: {
            title: "登录",
            auth: false
        }
    },
    {
        name: "wechatAuthLogin",
        path: "/login/wechatAuthLogin",
        component: () => import("@/view/login/wechat-auth-login"),
        meta: {
            title: "授权登录",
            auth: false
        }
    },
    {
        name: "luanch",
        path: "/luanch",
        component: () => import("@/view/luanch"),
        meta: {
            title: "闪屏",
            auth: false
        }
    },
    {
        name: "register",
        path: "/register",
        component: () => import("@/view/register"),
        meta: {
            title: "注册",
            auth: false
        }
    },
    {
        name: "channelLogin",
        path: "/channelLogin",
        component: () => import("@/view/login/channel-login"),
        meta: {
            title: "授权登录",
            auth: false
        }
    },

    {
        name: "newbie",
        path: "/newbie",
        component: () => import("@/view/newbie"),
        meta: {
            title: "新手礼包"
        }
    },

    /* {
      name: "licence",
      path: "/licence",
      component: () => import("@/view/licence"),
      meta: {
        title: "牌照资质"
      }
    }, */

    {
        name: "user",
        path: "/user",
        component: () => import("@/view/user"),
        meta: {
            title: "我的",
            hasLogin: true,
        }
    },
    {
        name: "personalCenter",
        path: "/personalCenter",
        component: () => import("@/view/personalCenter"),
        meta: {
            title: "个人中心",
        },
    },
    {
        name: "personalCenter-loginpwd1",
        path: "/personalCenter-loginpwd1",
        component: () => import("@/view/personalCenter/loginpwd_1"),
        meta: {
            title: "登录密码设置"
        }
    },
    {
        name: "personalCenter-loginpwd2",
        path: "/personalCenter-loginpwd2",
        component: () => import("@/view/personalCenter/loginpwd_2"),
        meta: {
            title: "登录密码设置"
        }
    },
    {
        name: "personalCenter-loginpwd3",
        path: "/personalCenter-loginpwd3",
        component: () => import("@/view/personalCenter/loginpwd_3"),
        meta: {
            title: "登录密码设置"
        }
    },
    {
        name: "updateDefaultCode",
        path: "/updateDefaultCode",
        component: () => import("@/view/personalCenter/defaultcode"),
        meta: {
            title: "更新默认验证码"
        }
    },
    {
        name: "personalCenter-loginpwd4",
        path: "/personalCenter-loginpwd4",
        component: () => import("@/view/personalCenter/loginpwd_4"),
        meta: {
            title: "登录密码设置"
        }
    },
    {
        name: "search_inviter",
        path: "/search_inviter",
        component: () => import("@/view/personalCenter/search_inviter"),
        meta: {
            title: "搜索邀请人列表"
        }
    },
    {
        name: "memberCenter",
        path: "/memberCenter",
        component: () => import("@/view/memberIntegral/memberCenter"),
        meta: {
            title: "会员中心",
            keepAlive: false,//是否需要进行缓存 true 需要 false 不需要
        },
    },
    {
        name: "everySigin",
        path: "/everySigin/:descTitle/:descriptions",
        component: () => import("@/view/memberIntegral/everySigin"),
        meta: {
            title: "每日签到",
        },
    },
    {
        name: "myIntegral",
        path: "/myIntegral",
        component: () => import("@/view/memberIntegral/myIntegral"),
        meta: {
            title: "我的积分",
        },
    },
    {
        name: "subscriptionCourtesy",
        path: "/subscriptionCourtesy/:descTitle/:descriptions",
        component: () => import("@/view/memberIntegral/subscriptionCourtesy"),
        meta: {
            title: "认购有礼",
        },
    },
    {
        name: "birthdayTreat",
        path: "/birthdayTreat/:descTitle/:descriptions",
        component: () => import("@/view/memberIntegral/birthdayTreat"),
        meta: {
            title: "生日礼遇",
        },
    },
    /**
     * 商品详情
     */
    {
        name: "productDetails",
        // path: "/productDetails/:listItem",
        path: "/productDetails",
        component: () => import("@/view/memberIntegral/order/productDetails"),
        meta: {
            title: "商品详情",
        },
    },
    /**
     * 确认订单
     */
    {
        name: "confirmOrder",
        // path: "/confirmOrder/:id/:num/:orderId/:address",
        path: "/confirmOrder",
        component: () => import("@/view/memberIntegral/order/confirmOrder"),
        meta: {
            title: "确认订单",
        },
    },
    {
        name: "myExchange",
        path: "/myExchange",
        component: () => import("@/view/memberIntegral/order/myExchange"),
        meta: {
            title: "我的兑换",
        }
    },
    {
        name: "allorder",
        path: "/allorder",
        component: () => import("@/view/memberIntegral/order/allorder"),
        meta: {
            title: "全部订单",
        }
    },
    {
        name: "orderDetail",
        path: "/orderDetail/:item",
        component: () => import("@/view/memberIntegral/order/orderDetail"),
        meta: {
            title: "全部订单详情",
        }
    },
    {
        name: "myaddress",
        path: "/myaddress",
        component: () => import("@/view/memberIntegral/myaddress/index"),
        meta: {
            title: "地址管理"
        }
    },
    {
        name: "myaddress-edit",
        path: "/myaddress/edit/:id?",
        component: () => import("@/view/memberIntegral/myaddress/addoredit"),
        meta: {
            title: "新建收货地址"
        }
    },
    {
        name: "integralMall",
        path: "/integralMall",
        component: () => import("@/view/memberIntegral/order/integralMall"),
        meta: {
            title: "积分商城",
        }
    },

    {
        name: "realname",
        path: "/realname",
        component: () => import("@/view/realname"),
        meta: {
            title: "实名认证"
        }
    },

    {
        name: "cardlist",
        path: "/cardlist",
        component: () => import("@/view/cardlist"),
        meta: {
            title: "银行卡管理"
        }
    },
    {
        name: "callback",
        path: "/callback",
        component: () => import("@/view/callback"),
        meta: {
            title: "回调页面"
        }
    },

    {
        name: "bindcard",
        path: "/bindcard",
        component: () => import("@/view/bindcard"),
        meta: {
            title: "绑定银行卡"
        }
    },
    {
        name: "recharge_1",
        path: "/recharge_1",
        component: () => import("@/view/recharge/index_1"),
        describe: "在线支付(已实名已绑卡)",
        meta: {
            title: "在线充值"
        }
    },
    {
        name: "recharge_2",
        path: "/recharge_2",
        component: () => import("@/view/recharge/index_2"),
        describe: "在线支付(已实名未绑卡)",
        meta: {
            title: "在线充值"
        }
    },
    {
        name: "recharge_3",
        path: "/recharge_3",
        component: () => import("@/view/recharge/index_3"),
        meta: {
            title: "在线充值"
        }
    },
    {
        name: "recharge_offline",
        path: "/recharge_offline",
        component: () => import("@/view/recharge/offline"),
        meta: {
            title: "线下充值"
        }
    },
    {
        name: "withdraw",
        path: "/withdraw",
        component: () => import("@/view/withdraw"),
        meta: {
            title: "提现"
        }
    },
    {
        name: "withdrawrecord",
        path: "/withdrawrecord",
        component: () => import("@/view/withdrawrecord"),
        meta: {
            title: "提现申请"
        }
    },

    {
        name: "withdraw/succ",
        component: () => import("@/view/withdraw/succ"),
        meta: {
            title: "提现成功"
        }
    },

    {
        name: "guide",
        path: "/guide",
        component: () => import("@/view/guide"),
        meta: {
            title: "新手引导"
        }
    },

    {
        name: "detail",
        path: "/detail/:channel?",
        component: () => import("@/view/detail"),

        meta: {
            title: "资产详情"
        }
    },
    {
        name: "detail-productdesc",
        path: "/detail/productdesc",
        component: () => import("@/view/detail/productdesc"),
        meta: {
            title: "公司和产品介绍"
        }
    },

    {
        name: "buying",
        path: "/buying",
        component: () => import("@/view/buying"),
        meta: {
            title: "买入"
        }
    },
    {
        name: "auctionBuying",
        path: "/auctionBuying",
        component: () => import("@/view/buying/auctionBuying"),
        meta: {
            title: "拍卖买入"
        }
    },
    {
        name: "special_buying",
        path: "/special_buying",
        component: () => import("@/view/buying/special_buying"),
        meta: {
            title: "特殊产品买入"
        }
    },
    {
        name: "experience_buying",
        path: "/experience_buying",
        component: () => import("@/view/buying/experience_buying"),
        meta: {
            title: "体验金产品买入"
        }
    },
    {
        name: "buying/succ",
        component: () => import("@/view/buying/succ"),
        meta: {
            title: "支付成功"
        }
    },
    {
        name: "orderconfirm",
        path: "/orderconfirm",
        component: () => import("@/view/order_confirm"),
        //  describe: "在线支付(已实名已绑卡)",
        meta: {
            title: "认购确认"
        }
    },
    {
        name: "payment_1",
        path: "/payment_1",
        component: () => import("@/view/payment/index_1"),
        describe: "在线支付(已实名已绑卡)",
        meta: {
            title: "在线支付"
        }
    },

    {
        name: "payment_2",
        path: "/payment_2",
        component: () => import("@/view/payment/index_2"),
        describe: "在线支付(已实名未绑卡)",
        meta: {
            title: "在线支付"
        }
    },

    {
        name: "payment_3",
        path: "/payment_3",
        component: () => import("@/view/payment/index_3"),
        describe: "在线支付(未实名未绑卡)",
        meta: {
            title: "在线支付"
        }
    },

    {
        name: "riskAssessment",
        path: "/riskAssessment",
        component: () => import("@/view/personalCenter/riskAssessment"),
        meta: {
            title: "风险测评列表",
        }
    },

    {
        name: "risks",
        path: "/risks",
        component: () => import("@/view/risks/entry.vue"),
        meta: {
            title: "风险承受能力评测"
        }
    },

    {
        name: "questions",
        path: "/questions",
        component: () => import("@/view/risks/questions.vue"),
        meta: {
            title: "风险承受能力评测"
        }
    },

    {
        name: "risksResults",
        path: "/risksResults",
        component: () => import("@/view/risks/risksResults.vue"),
        meta: {
            title: "评测结果"
        }
    },

    {
        name: "invest",
        path: "/invest",
        component: () => import("@/view/invest"),
        meta: {
            title: "投资"
        }
    },

    {
        name: "result",
        path: "/result",
        component: () => import("@/view/result"),
        meta: {
            title: "认购成功"
        }
    },

    {
        name: "gesture",
        path: "/gesture",
        component: () => import("@/view/gesture"),
        meta: {
            title: "手势密码"
        }
    },

    {
        name: "tradingRecord",
        path: "/tradingRecord",
        component: () => import("@/view/trading"),
        meta: {
            title: "交易记录"
        }
    },
    {
        name: "investRecord",
        path: "/investRecord",
        component: () => import("@/view/investrecord"),
        meta: {
            title: "我的理财"
        }
    },
    // -----------------------------------------------------------------------------------------------------------
    // + 我的积分
    {
        name: "pointsmall",
        path: "/pointsmall",
        component: () => import("@/view/pointsmall"),
        meta: {
            title: "我的积分"
        }
    },

    // + 可用积分
    {
        name: "pointsmingxi",
        path: "/pointsmingxi",
        component: () => import("@/view/pointsmingxi"),
        meta: {
            title: "积分明细"
        }
    },

    // + 赚取积分
    {
        name: "pointsasmoney",
        path: "/pointsasmoney",
        component: () => import("@/view/pointsasmoney"),
        meta: {
            title: "积分当钱花"
        }
    },

    // + 积分说明
    {
        name: "description",
        path: "/description",
        component: () => import("@/view/description"),
        meta: {
            title: "积分说明"
        }
    },

    // + 投资以下产品可获积分奖励
    {
        name: "rebatepoints",
        path: "/rebatepoints",
        component: () => import("@/view/rebatepoints"),
        meta: {
            title: "投资以下产品可获积分奖励"
        }
    },

    // + 我的理财-认购详情
    {
        name: "subscribe",
        path: "/subscribe/:id/:status",
        component: () => import("@/view/subscribe"),
        props: true,
        meta: {
            title: "认购详情"
        }
    },

    // --------------------------------------------------------------------------------------------------------------------------
    {
        name: "balance",
        path: "/balance",
        component: () => import("@/view/balance"),
        meta: {
            title: "余额"
        }
    },

    {
        name: "options",
        path: "/options",
        component: () => import("@/view/options"),
        meta: {
            title: "设置"
        }
    },
    {
        name: "options-aboutus",
        path: "/options-aboutus",
        component: () => import("@/view/options/aboutus"),
        meta: {
            title: "关于我们"
        }
    },
    {
        name: "invite",
        path: "/invite",
        component: () => import("@/view/invite"),
        meta: {
            title: "我的邀请"
        }
    },
    {
        name: "invitecode",
        path: "/invite/code",
        component: () => import("@/view/invite/my_invite_code.vue"),
        meta: {
            title: "我的邀请"
        }
    },
    {
        name: "invitelist",
        path: "/invite/list",
        component: () => import("@/view/invite/my_invite_list.vue"),
        meta: {
            title: "我的邀请"
        }
    },
    {
        name: "changephone",
        path: "/changephone",
        component: () => import("@/view/changephone"),
        meta: {
            title: "更换手机号"
        }
    },
    {
        name: "agreement",
        path: "/agreement",
        component: () => import("@/view/agreement"),
        meta: {
            title: "协议"
        }
    },
    {
        name: "agreement/pdfDetail",
        path: "/agreement",
        component: () => import("@/view/agreement/pdfDetail"),
        meta: {
            title: "资产档案"
        }
    },
    {
        name: "lookPdfUrlFile",
        path: "agreement/lookPdfUrlFile",
        component: () => import("@/view/agreement/lookPdfUrlFile"),
        meta: {
            title: "查看PDF URL文件",
        }
    },
    {
        path: "/agreement/reg",
        name: "agreement-reg",
        component: () => import("@/view/agreement/reg"),
        meta: {
            title: "服务协议"
        }
    },
    {
        path: "/agreement/relief",
        name: "agreement-relief",
        component: () => import("@/view/agreement/relief"),
        meta: {
            title: "免责声明"
        }
    },
    {
        path: "/agreement/investor",
        name: "agreement-investor",
        component: () => import("@/view/agreement/investor"),
        meta: {
            title: "合格投资者承诺函"
        }
    },
    {
        path: "/agreement/trade",
        name: "agreement-trade",
        component: () => import("@/view/agreement/trade"),
        meta: {
            title: "交易协议"
        }
    },
    {
        path: "/agreement/privacy",
        name: "agreement-privacy",
        component: () => import("@/view/agreement/privacy"),
        meta: {
            title: "天安金交中心-隐私协议"
        }
    },
    {
        path: "/agreement/userPrivacy",
        name: "agreement-userPrivacy",
        component: () => import("@/view/agreement/userPrivacy"),
        meta: {
            title: "天安金交中心-隐私协议"
        }
    },
    {
        path: "/agreement/shop",
        name: "agreement-shop",
        component: () => import("@/view/agreement/shop"),
        meta: {
            title: "商品兑换免责说明"
        }
    },
    {
        name: "webview",
        path: "/webview/:title/:url",
        component: () => import("@/view/agreement/webview"),
        meta: {
            title: "webview查看"
        }
    },

    {
        name: "develop",
        path: "/develop",
        component: () => import("@/view/develop"),
        meta: {
            title: "天安金交中心-开发中"
        }
    },
    {
        name: "preview",
        path: "/preview",
        component: () => import("@/view/preview"),
        meta: {
            title: "天安金交中心-预览"
        }
    },

    /**   以下为小程序参与使用的 route   */
    {
        name: "paySuccess",
        path: "/paysuccess",
        component: () => import("@/view/payment/success"),
        meta: {
            title: "支付完成"
        }
    },
    {
        name: "payWait",
        path: "/payWait",
        component: () => import("@/view/payment/wait"),
        meta: {
            title: "支付完成"
        }
    },
    {
        name: "rechargeSuccess",
        path: "/rechargesuccess",
        component: () => import("@/view/recharge/success"),
        meta: {
            title: "充值完成"
        }
    },
    {
        name: "applet-agreement",
        path: "/applet-agreement",
        component: () => import("@/view/applet/agreement/index"),
        meta: {
            title: "协议"
        }
    },
    {
        name: "applet-agreement-investor",
        path: "/applet-agreement-investor",
        component: () => import("@/view/applet/agreement/investor"),
        meta: {
            title: "协议"
        }
    },
    {
        name: "applet-pay-course",
        path: "/applet-pay-course",
        component: () => import("@/view/applet/pay/course"),
        meta: {
            title: "支付"
        }
    },
    {
        name: "buyprom",
        path: "/buyprom",
        component: () => import("@/view/buyprom"),
        meta: {
            title: "买入体验产品"
        }
    },
    {
        name: "coupon-list",
        path: "/coupon/list",
        component: () => import("@/view/coupon/list"),
        meta: {
            title: "我的福利券"
        }
    },
    {
        name: "coupon",
        path: "/coupon",
        component: () => import("@/view/coupon"),
        meta: {
            title: "我的优惠券"
        }
    },
    {
        name: "coupon-ticket",
        path: "/coupon/ticket",
        component: () => import("@/view/coupon/ticket"),
        meta: {
            title: "我的奖票"
        }
    },
    {
        name: "coupon-redenvelope",
        path: "/coupon/redenvelope",
        component: () => import("@/view/coupon/redenvelope"),
        meta: {
            title: "我的红包"
        }
    },
    {
        name: "coupon-redenvelopetips",
        path: "/coupon-redenvelopetips",
        component: () => import("@/view/coupon/redenvelopetips"),
        meta: {
            title: "迎新年活动"
        }
    },
    {
        name: "address",
        path: "/address",
        component: () => import("@/view/address/index"),
        meta: {
            title: "我的收货地址"
        }
    },
    {
        name: "address-choose",
        path: "/address/choose",
        component: () => import("@/view/address/choose"),
        meta: {
            title: "选择收货地址"
        }
    },
    {
        name: "address-edit",
        path: "/address/edit/:id?",
        component: () => import("@/view/address/edit"),
        meta: {
            title: "编辑收货地址"
        }
    },
    /**
     * 幸运抽奖
     */
    {
        name: "lottery",
        path: "/lottery",
        // component: () => import("@/view/lottery/index"),
        component: () => import("@/view/lottery/index10"),
        meta: {
            title: "幸运大转盘",
            //静默登录，如果有有效的token则不弹出登录页面，而是直接获取用户信息
            //详情查看router.beforeEach
            silenceAuth: true
        }
    },
    {
        name: "aprilLotter",
        path: "/aprilLotter",
        component: () => import("@/view/lottery/aprilLotter"),
        meta: {
            title: "四月活动大转盘",
            //静默登录，如果有有效的token则不弹出登录页面，而是直接获取用户信息
            //详情查看router.beforeEach
            silenceAuth: true
        }
    },
    {
        name: "sixLotter",
        path: "/sixLotter",
        component: () => import("@/view/lottery/sixLotter"),
        meta: {
            title: "签到抽奖",
            //静默登录，如果有有效的token则不弹出登录页面，而是直接获取用户信息
            //详情查看router.beforeEach
            silenceAuth: true
        }
    },
    {
        name: "sevenLotter",
        path: "/sevenLotter",
        component: () => import("@/view/lottery/sevenLotter"),
        meta: {
            title: "七月活动抽盲盒",
            //静默登录，如果有有效的token则不弹出登录页面，而是直接获取用户信息
            //详情查看router.beforeEach
            silenceAuth: true
        }
    },
    {
        name: "shake",
        path: "/shake",
        component: () => import("@/view/lottery/shake"),
        meta: {
            title: "摇一摇抽奖",
            //静默登录，如果有有效的token则不弹出登录页面，而是直接获取用户信息
            //详情查看router.beforeEach
            silenceAuth: true
        }
    },

    {
        name: "payinit",
        path: "/mpayweb/payinit",
        component: () => import("@/view/payment/mock/index"),
        meta: {
            title: "收银台",
            auth: "false"
        }
    },

    {
        name: "payresult",
        path: "/mpayweb/payresult",
        component: () => import("@/view/payment/mock/result"),
        meta: {
            title: "收银台",
            auth: "false"
        }
    },

    /*
     *  资讯模块
     */
    {
        name: "news",
        path: "/news",
        component: () => import("@/view/news/index"),
        meta: {
            title: "资讯",
        }
    },
    {
        name: "news-detail",
        path: "/news-detail",
        component: () => import("@/view/news/detail"),
        meta: {
            title: "资讯详情",
        }
    },
    /*
     *  消息中心
     */
    {
        path: "/notify",
        component: () => import("@/view/msgCenter/notify/layout"),
        meta: {
            title: "消息中心",
        },
        children: [
            {
                name: "notify-list",
                path: "",
                component: () => import("@/view/msgCenter/notify/index"),
                meta: {
                    title: "消息中心",
                },
            },
            {
                name: "notify-view",
                path: ":id",
                component: () => import("@/view/msgCenter/notify/view"),
                meta: {
                    title: "消息中心",
                },
            }
        ]
    },
    /*
     *  公告模块
     */
    {
        path: "/notice",
        component: () => import("@/view/notice/index"),
        meta: { title: "公告", auth: false },
        children: [
            {
                name: "notice-list",
                path: "",
                component: () => import("@/view/notice/list/index"),
                meta: {
                    auth: false,
                    title: "公告列表",
                },
            },
            {
                name: "notice-detail",
                path: ":id",
                component: () => import("@/view/notice/detail/index"),
                meta: {
                    auth: false,
                    title: "公告详情",
                },
            }
        ]
    },
    {
        name: "shop",
        path: "/shop",
        component: () => import("@/view/shop/layout"),
        meta: {
            title: "商品",
        },
        children: [
            {
                name: "shop-product",
                path: "product/:id",
                component: () => import("@/view/shop/product/detail"),
                meta: {
                    auth: false,
                    title: "商品详情",
                }
            },
            {
                name: "shop-product-buy",
                path: "buy",
                component: () => import("@/view/shop/product/buy"),
                meta: {
                    title: "商品购买",
                },
            },
            {
                name: "shop-pay-success",
                path: "pay/success/:id",
                component: () => import("@/view/shop/order/pay_success"),
                meta: {
                    title: "商品支付成功",
                },
            },
            {
                name: "shop-pay",
                path: "pay/:id",
                component: () => import("@/view/shop/order/pay"),
                meta: {
                    title: "商品支付",
                },
            },
            {
                name: "shop-order-list",
                path: "order/list",
                component: () => import("@/view/shop/order/list"),
                meta: {
                    title: "商品订单列表",
                },
            },
            {
                name: "shop-order-view",
                path: "order/:id",
                component: () => import("@/view/shop/order/view"),
                meta: {
                    title: "商品订单详情",
                },
            },
            {
                name: "shop-after-refund",
                path: "refund/:id",
                component: () => import("@/view/shop/after/refund"),
                meta: {
                    title: "商品退款",
                },
            },
            {
                name: "shop-after-refund-view",
                path: "refundview/:id",
                component: () => import("@/view/shop/after/refund_view"),
                meta: {
                    title: "商品退款",
                },
            },
            {
                name: "shop-wx-auth",
                path: "wx_auth",
                component: () => import("@/view/shop/order/wx_auth"),
                meta: {
                    title: "授权登录",
                    auth: false
                }
            },
            {
                name: "settingPwd",
                path: "/settingPwd",
                component: () => import("@/view/settingPwd/index"),
                meta: {
                    title: "设置密码",
                }
            },
            {
                name: "myorder",
                path: "/myorder",
                component: () => import("@/view/myorder/index"),
                meta: {
                    title: "我的订单",
                }
            },
            {
                name: "myauction",
                path: "/myauction",
                component: () => import("@/view/myauction/index"),
                meta: {
                    title: "委托竞拍",
                }
            },
            //我的拍卖详情
            {
                name: "auctionDetail",
                path: "/auctionDetail/:productId/:status",
                component: () => import("@/view/myauction/auctionDetail"),
                props: true,
                meta: {
                    title: "拍卖详情"
                }
            },
            {
                name: "claimDetail",
                path: "/claimDetail/:channel?",
                component: () => import("@/view/myauction/claimDetail"),
                meta: {
                    title: "债权详情"
                }
            },
            {
                name: 'myagreement',
                path: '/myagreement',
                component: () => import("@/view/myagreement"),
                meta: {
                    title: "我的协议"
                }
            },
            {
                name: "myauction1",
                path: "/myauction1",
                component: () => import("@/view/myauction1/index"),
                meta: {
                    title: "我的竞买",
                }
            },
            //我的拍卖详情
            {
                name: "auctionDetail1",
                path: "/auctionDetail1/:productId/:status",
                component: () => import("@/view/myauction1/auctionDetail"),
                props: true,
                meta: {
                    title: "竞拍详情"
                }
            },
            {
                name: "claimDetail1",
                path: "/claimDetail1/:channel?",
                component: () => import("@/view/myauction1/claimDetail"),
                meta: {
                    title: "竞拍详情"
                }
            },
        ]
    },
    {
        name: "myexclusive",
        path: "/myexclusive",
        component: () => import("@/view/myexclusive/index"),
        meta: {
            title: "我的专享",
        }
    },
    {
        name: "myexclusive-companydesc",
        path: "/myexclusive/companydesc",
        component: () => import("@/view/myexclusive/companydesc"),
        meta: {
            title: "公司介绍"
        }
    },
    {
        name: "anniversarycelebration",
        path: "/anniversarycelebration",
        component: () => import("@/view/anniversarycelebration"),
        meta: {
            title: "周年庆活动"
        }
    },
    {
        name: "anniversarydetials",
        path: "/anniversarydetials",
        component: () => import("@/view/anniversarycelebration/detials.vue"),
        meta: {
            title: "周年庆活动详情"
        }
    },
    {
        name: "experience_rule",
        path: "/experience_rule",
        component: () => import("@/view/coupon/experience_rule"),
        meta: {
            title: "体验金券详情"
        }
    },
    {
        name: "experience_ing",
        path: "/experience_ing",
        component: () => import("@/view/order_confirm/experience_ing"),
        meta: {
            title: "体验金体验中"
        }
    },
    {
        name: "downloadapp",
        path: "/downloadapp",
        component: () => import("@/view/downloadapp/index"),
        meta: {
            title: "app下载"
        }
    },
    {
        name: 'mall-template',
        path: "/mall-template",
        component: () => import("@/view/template/mall-template"),
        meta: {
            title: "积分商城模版",
        }
    },
    {
        name: 'answerdraw',
        path: "/answerdraw",
        component: () => import("@/view/answerdraw/index"),
        meta: {
            title: "答题抽奖",
            //静默登录，如果有有效的token则不弹出登录页面，而是直接获取用户信息
            //详情查看router.beforeEach
            silenceAuth: true
        }
    },
    {
        name: 'blindbox',
        path: "/blindbox",
        component: () => import("@/view/answerdraw/blindbox"),
        meta: {
            title: "盲盒",
            //静默登录，如果有有效的token则不弹出登录页面，而是直接获取用户信息
            //详情查看router.beforeEach
            silenceAuth: true
        }
    },
    {
        name: 'introduce',
        path: "/introduce",
        component: () => import("@/view/answerdraw/introduce"),
        meta: {
            title: "活动介绍",
            //静默登录，如果有有效的token则不弹出登录页面，而是直接获取用户信息
            //详情查看router.beforeEach
            silenceAuth: true
        }
    },
    {
        name: 'webview-page',
        path: "/webview-page",
        component: () => import("@/view/webview/index"),
        meta: {
            title: "网页",
        }
    },
];

// add route path
routes.forEach(route => {
    route.path = route.path || "/" + (route.name || "");
});

export { routes }